import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ApContentModule } from '@ap/content';
import { ApErrorModule } from '@ap/error';
import { ApHeaderComponent } from '@ap/header';
import { MKFooterModule } from '@ap/kantoor-template';
import { AUTORISATIE_API_KEY } from '@ap/interface-apix-mk-autorisatie';

import { KantoorSignComponent } from './sign/kantoor-sign.component';
import { BrowserErrorComponent } from './error/browser-error/browser-error.component';
import { MKErrorModule } from './error/error.module';
import { KantoorLoginComponent } from './kantoor-login.component';
import { KantoorSignModule } from './sign/kantoor-sign.module';
import { KantoorLoginService } from './kantoor-login.service';
import { LogoutPageComponent } from './logout-page/logout-page.component';
import { LogoutPageModule } from './logout-page/logout-page.module';
import { MKAppsPageModule } from './apps-page/apps-page.module';

const routes: Routes = [
    {
        path: '',
        component: KantoorSignComponent
    },
    {
        path: 'browser',
        component: BrowserErrorComponent
    },
    {
        path: 'uitgelogd',
        component: LogoutPageComponent
    }
];

/**
 * @ngdoc module
 * @name KantoorLoginModule
 */
@NgModule({
    declarations: [KantoorLoginComponent],
    providers: [KantoorLoginService, { provide: AUTORISATIE_API_KEY, useValue: '{<MK_AUTORISATIE_API_KEY>}' }],
    imports: [
        KantoorSignModule,
        BrowserModule,
        ApErrorModule,
        MKAppsPageModule,
        ApContentModule,
        BrowserAnimationsModule,
        MKFooterModule,
        MKErrorModule,
        LogoutPageModule,
        RouterModule.forRoot(routes, { useHash: true }),
        ApHeaderComponent
    ],
    bootstrap: [KantoorLoginComponent]
})
export class KantoorLoginModule {}
